// extracted by mini-css-extract-plugin
export default {"container":"it3A0j","info":"qCpqqS","title":"tjiFfo","subtitle":"mRblIU"};